export default __webpack_public_path__ + "static/pe-fb8d5c7042ef418ea8ca2875112fd0fb.svg";